// extracted by mini-css-extract-plugin
export var askAiIcon = "_o4-j";
export var category = "_o4-9";
export var categoryHeader = "_o4-e";
export var container = "_o4-0";
export var group = "_o4-a";
export var groupItems = "_o4-f";
export var groupSeparator = "_o4-k";
export var loading = "_o4-1";
export var noResults = "_o4-3";
export var placeholder = "_o4-2";
export var resultContent = "_o4-5";
export var resultIcon = "_o4-c";
export var resultItem = "_o4-g";
export var resultMeta = "_o4-8";
export var resultSubtitle = "_o4-7";
export var resultSuffix = "_o4-i";
export var resultTitle = "_o4-6";
export var resultsList = "_o4-4";
export var searchGroup = "_o4-d";
export var selected = "_o4-h";
export var subgroup = "_o4-b";